/**
 * This module adds a polyfill to detect high contrast mode and set a CSS class on the document
 * to enable our forced-colors-mode CSS rules
 */

export const setupHighContrastDetection = (): void => {
  // Check if the browser supports forced-colors media query
  const mediaQuery = window.matchMedia('(forced-colors: active)');
  
  // Function to update the document class based on high contrast mode
  const updateHighContrastClass = (isHighContrast: boolean): void => {
    if (isHighContrast) {
      document.documentElement.classList.add('forced-colors-mode');
    } else {
      document.documentElement.classList.remove('forced-colors-mode');
    }
  };

  // Set initial state
  updateHighContrastClass(mediaQuery.matches);

  // Listen for changes
  mediaQuery.addEventListener('change', (e) => {
    updateHighContrastClass(e.matches);
  });

  // Legacy detection for older browsers that don't support forced-colors
  // This is a workaround and not 100% accurate
  if (!('matchMedia' in window && window.matchMedia('(forced-colors: active)').matches)) {
    // Try to detect high contrast mode using a side effect approach
    const testElement = document.createElement('div');
    testElement.style.border = '1px solid red';
    testElement.style.position = 'absolute';
    testElement.style.height = '1px';
    testElement.style.width = '1px';
    testElement.style.left = '-999px';
    document.body.appendChild(testElement);
    
    const computedStyle = getComputedStyle(testElement);
    const isMsHighContrast = computedStyle.borderTopColor === computedStyle.borderRightColor;
    
    if (isMsHighContrast) {
      document.documentElement.classList.add('forced-colors-mode');
    }
    
    document.body.removeChild(testElement);
  }
};

export default setupHighContrastDetection;
